import React from 'react';
import * as RadioGroup from '@radix-ui/react-radio-group';

import styles from './option-card-group.module.scss';

export type OptionCard = {
  value: string;
  title: string;
  description?: string;
  disabled?: boolean;
};

type OptionCardGroupProps = {
  value: string;
  onChange: (value: string) => void;
  options: OptionCard[];
  name?: string;
  'aria-label'?: string;
};

/**
 * A vertical list of selectable cards, each with a title and a description.
 * Single choice, so it is backed by a radio group rather than a menu.
 */
export const OptionCardGroup: React.FC<OptionCardGroupProps> = ({
  value,
  onChange,
  options,
  name,
  'aria-label': ariaLabel,
}) => (
  <RadioGroup.Root
    className={styles.group}
    value={value}
    onValueChange={onChange}
    name={name}
    aria-label={ariaLabel}
  >
    {options.map((option) => (
      <RadioGroup.Item
        key={option.value}
        className={styles.card}
        value={option.value}
        disabled={option.disabled}
      >
        <span className={styles.title}>{option.title}</span>

        {option.description && <span className={styles.description}>{option.description}</span>}
      </RadioGroup.Item>
    ))}
  </RadioGroup.Root>
);
